import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import axios from 'axios';
import { Md5 } from 'ts-md5';
import { setToken } from '@/utils/auth';
import { registerShowModal, onReAuthSuccess } from '@/utils/reAuth';

import { ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  __name: 'index',
  setup(__props) {
    const visible = ref(false);
    const loading = ref(false);
    const formRef = ref();
    const formData = ref({
      account: JSON.parse(localStorage.getItem('userInfo') || '{}').account || '',
      password: ''
    });
    const rules = {
      account: [{
        required: true,
        message: '请输入用户名',
        trigger: 'blur'
      }],
      password: [{
        required: true,
        message: '请输入密码',
        trigger: 'blur'
      }, {
        min: 6,
        message: '密码不能少于6位',
        trigger: 'blur'
      }]
    };
    onMounted(() => {
      registerShowModal(() => {
        visible.value = true;
      });
    });
    async function handleSubmit() {
      const valid = await formRef.value?.validate().catch(() => false);
      if (!valid) return;
      loading.value = true;
      try {
        const res = await axios.post('/evaluate-api/api/project-management/external-user/login', {
          account: formData.value.account,
          password: Md5.hashStr(formData.value.password).toUpperCase()
        });
        const {
          code,
          data,
          msg
        } = res.data;
        if (code === '200' && data?.token) {
          setToken(data.token);
          if (data.user) {
            localStorage.setItem('userInfo', JSON.stringify(data.user));
          }
          visible.value = false;
          formData.value.password = '';
          onReAuthSuccess(data.token);
        } else if (code === 'user.password-error') {
          ElMessage.error('用户名或密码错误');
        } else {
          ElMessage.error(msg || '登录失败');
        }
      } catch {
        ElMessage.error('网络错误，请重试');
      } finally {
        loading.value = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "400px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        "append-to-body": ""
      }, {
        header: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("div", {
          class: "dialog-header"
        }, [_createElementVNode("span", {
          class: "dialog-title"
        }, "会话已过期，请重新登录")], -1)])),
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          style: {
            "width": "100%"
          },
          loading: _unref(loading),
          onClick: handleSubmit
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode(" 重新登录 ")])),
          _: 1,
          __: [4]
        }, 8, ["loading"])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: _unref(formData),
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "account"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(formData).account,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(formData).account = $event),
              placeholder: "用户名",
              size: "large"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "password"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(formData).password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(formData).password = $event),
              type: "password",
              placeholder: "密码",
              size: "large",
              "show-password": "",
              onKeyup: _withKeys(handleSubmit, ["enter"])
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};